import { render, staticRenderFns } from "./SimpleCollapse.vue?vue&type=template&id=041ccd4a"
import script from "./SimpleCollapse.vue?vue&type=script&lang=js"
export * from "./SimpleCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('041ccd4a')) {
      api.createRecord('041ccd4a', component.options)
    } else {
      api.reload('041ccd4a', component.options)
    }
    module.hot.accept("./SimpleCollapse.vue?vue&type=template&id=041ccd4a", function () {
      api.rerender('041ccd4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/components/SimpleCollapse.vue"
export default component.exports